import './style.scss';
import './editor.scss';
import Edit from './edit.jsx';
import metadata from './block.json';

const { registerBlockType, createBlock } = wp.blocks;

const serializeAttrsForShortcode = (obj) => {
  try {
    return JSON.stringify(obj || {}).replace(/'/g, '&apos;');
  } catch {
    return '{}';
  }
};

registerBlockType(metadata.name, {
  ...metadata,
  edit: Edit,
  save: () => null,
});
